var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "160px",
    height: "160px",
    viewBox: "0 0 160 160",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-68.2%",
    y: "-53.2%",
    width: "236.5%",
    height: "206.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.276   0 0 0 0 0.3624   0 0 0 0 0.6  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "path-4",
    cx: 19.2,
    cy: 19.2,
    r: 19.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-6",
    x: 34.0686869,
    y: 22.8945455,
    width: 6.04444444,
    height: 18.24,
    rx: 3.02222222
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-496.3%",
    y: "-164.5%",
    width: "1092.6%",
    height: "428.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.35   0 0 0 0 0.495833333   0 0 0 0 0.7  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 34.0686869,
    y: 44.0145455,
    width: 6.04444444,
    height: 6.08,
    rx: 3.02222222
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-496.3%",
    y: "-493.4%",
    width: "1092.6%",
    height: "1086.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.35   0 0 0 0 0.495833333   0 0 0 0 0.7  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File-view-illustration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B8C4E6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A6B4DB",
    mask: "url(#mask-2)",
    points: "160 0 0 160 160 160"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    filter: "url(#filter-3)",
    transform: "translate(38.080000, 25.600000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#6E82B8",
    x: 9.89090909,
    y: 9.89090909,
    width: 74.1818182,
    height: 98.9090909,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.4545455,76.9636364 L34.6895105,108.8 L17.8909091,108.8 C13.4726311,108.8 9.89090909,105.218278 9.89090909,100.8 L9.89090909,98.7177866 L9.89090909,94.2778121 L66.4545455,76.9636364 Z",
    id: "Path-2",
    fill: "#5D74B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,0 L66.1818182,0 C70.6000962,-8.11624501e-16 74.1818182,3.581722 74.1818182,8 L74.1818182,69.2363636 L44.5090909,98.9090909 L8,98.9090909 C3.581722,98.9090909 5.41083001e-16,95.3273689 0,90.9090909 L0,8 C-5.41083001e-16,3.581722 3.581722,8.11624501e-16 8,0 Z",
    id: "Rectangle",
    fill: "#F0F3FA"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#DDE2F0",
    points: "46.0191163 72.2918436 19.4372982 98.8736618 44.7267778 98.8736618"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.5090909,69.2363636 L74.1818182,69.2363636 L44.5090909,98.9090909 L44.5090909,77.2363636 C44.5090909,72.8180856 48.0908129,69.2363636 52.5090909,69.2363636 Z",
    id: "Rectangle",
    fill: "#B8C4E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-5",
    transform: "translate(17.920000, 17.309091)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#B8C4E6",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#A6B4DB",
    mask: "url(#mask-5)",
    points: "38.4 0 0 38.4 38.4 38.4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-6"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F3FA",
    fillRule: "evenodd",
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-9)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#F0F3FA",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPreview);
export default __webpack_public_path__ + "static/media/no-preview.a1cd2f99d3479d7dcd90ca1231458795.svg";
export { ForwardRef as ReactComponent };